// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageProjectRead,
  PageProjectReadFromJSON,
  PageProjectReadToJSON,
} from "../models/PageProjectRead";
import {
  type PageProjectUser,
  PageProjectUserFromJSON,
  PageProjectUserToJSON,
} from "../models/PageProjectUser";
import {
  type ProjectCreate,
  ProjectCreateFromJSON,
  ProjectCreateToJSON,
} from "../models/ProjectCreate";
import { type ProjectRead, ProjectReadFromJSON, ProjectReadToJSON } from "../models/ProjectRead";
import {
  type ProjectResponse,
  ProjectResponseFromJSON,
  ProjectResponseToJSON,
} from "../models/ProjectResponse";
import { type ProjectRole, ProjectRoleFromJSON, ProjectRoleToJSON } from "../models/ProjectRole";
import {
  type ProjectStatus,
  ProjectStatusFromJSON,
  ProjectStatusToJSON,
} from "../models/ProjectStatus";
import {
  type ProjectUpdate,
  ProjectUpdateFromJSON,
  ProjectUpdateToJSON,
} from "../models/ProjectUpdate";
import { type ProjectUser, ProjectUserFromJSON, ProjectUserToJSON } from "../models/ProjectUser";
import {
  type ProjectUserUpdate,
  ProjectUserUpdateFromJSON,
  ProjectUserUpdateToJSON,
} from "../models/ProjectUserUpdate";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface ProjectCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectCreate: ProjectCreate;
}

export interface ProjectDestroyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
}

export interface ProjectListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: ProjectListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Filter by project status
   */
  status?: ProjectStatus;
  /**
   *
   */
  code?: string | null;
  /**
   *
   */
  slug?: string | null;
  /**
   * Case-insensitive substring search on project name
   */
  search?: string | null;
  /**
   * Filter by user ID with a role assigned in the project
   */
  projectUserId?: string | null;
}

export interface ProjectPermissionsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
}

export interface ProjectRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
}

export interface ProjectUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  projectUpdate: ProjectUpdate;
}

export interface ProjectUserListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: ProjectUserListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Full text search on name and email
   */
  search?: string | null;
  /**
   * Role to filter on
   */
  role?: ProjectRole | null;
  /**
   * Filter on account state
   */
  active?: boolean | null;
}

export interface ProjectUserRoleDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  userId: string;
}

export interface ProjectUserRoleUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  userId: string;
  /**
   *
   */
  projectUserUpdate: ProjectUserUpdate;
}

/**
 *
 */
export class ProjectsApi extends runtime.BaseAPI {
  /**
   * Creates request options for projectCreate without sending the request
   */
  async projectCreateRequestOpts(
    requestParameters: ProjectCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectCreate().'
      );
    }

    if (requestParameters["projectCreate"] == null) {
      throw new runtime.RequiredError(
        "projectCreate",
        'Required parameter "projectCreate" was null or undefined when calling projectCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_create",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectCreateToJSON(requestParameters["projectCreate"]),
    };
  }

  /**
   * Provide relevant details for the to be created project.
   * create new project
   */
  async projectCreateRaw(
    requestParameters: ProjectCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectResponse>> {
    const requestOptions = await this.projectCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
  }

  /**
   * Provide relevant details for the to be created project.
   * create new project
   */
  async projectCreate(
    requestParameters: ProjectCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectResponse> {
    const response = await this.projectCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectDestroy without sending the request
   */
  async projectDestroyRequestOpts(
    requestParameters: ProjectDestroyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDestroy().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDestroy().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * delete a project
   */
  async projectDestroyRaw(
    requestParameters: ProjectDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.projectDestroyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * delete a project
   */
  async projectDestroy(
    requestParameters: ProjectDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for projectList without sending the request
   */
  async projectListRequestOpts(
    requestParameters: ProjectListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["code"] != null) {
      queryParameters["code"] = requestParameters["code"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["projectUserId"] != null) {
      queryParameters["project_user_id"] = requestParameters["projectUserId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_list",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of projects for a specific tenant.
   * list projects
   */
  async projectListRaw(
    requestParameters: ProjectListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageProjectRead>> {
    const requestOptions = await this.projectListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageProjectReadFromJSON(jsonValue));
  }

  /**
   * Return a list of projects for a specific tenant.
   * list projects
   */
  async projectList(
    requestParameters: ProjectListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageProjectRead> {
    const response = await this.projectListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectPermissions without sending the request
   */
  async projectPermissionsRequestOpts(
    requestParameters: ProjectPermissionsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectPermissions().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectPermissions().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/permissions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return list is of available permissions for user in tenant.
   * list of available permissions
   */
  async projectPermissionsRaw(
    requestParameters: ProjectPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: boolean | null }>> {
    const requestOptions = await this.projectPermissionsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Return list is of available permissions for user in tenant.
   * list of available permissions
   */
  async projectPermissions(
    requestParameters: ProjectPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: boolean | null }> {
    const response = await this.projectPermissionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectRetrieve without sending the request
   */
  async projectRetrieveRequestOpts(
    requestParameters: ProjectRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectRetrieve().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual project.
   * show project details
   */
  async projectRetrieveRaw(
    requestParameters: ProjectRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectRead>> {
    const requestOptions = await this.projectRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectReadFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual project.
   * show project details
   */
  async projectRetrieve(
    requestParameters: ProjectRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectRead> {
    const response = await this.projectRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectUpdate without sending the request
   */
  async projectUpdateRequestOpts(
    requestParameters: ProjectUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectUpdate().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectUpdate().'
      );
    }

    if (requestParameters["projectUpdate"] == null) {
      throw new runtime.RequiredError(
        "projectUpdate",
        'Required parameter "projectUpdate" was null or undefined when calling projectUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectUpdateToJSON(requestParameters["projectUpdate"]),
    };
  }

  /**
   * Provide relevant details for an update of an existing project.
   * update an existing project
   */
  async projectUpdateRaw(
    requestParameters: ProjectUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectResponse>> {
    const requestOptions = await this.projectUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
  }

  /**
   * Provide relevant details for an update of an existing project.
   * update an existing project
   */
  async projectUpdate(
    requestParameters: ProjectUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectResponse> {
    const response = await this.projectUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectUserList without sending the request
   */
  async projectUserListRequestOpts(
    requestParameters: ProjectUserListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectUserList().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectUserList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["role"] != null) {
      queryParameters["role"] = requestParameters["role"];
    }

    if (requestParameters["active"] != null) {
      queryParameters["active"] = requestParameters["active"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/users`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show all users with their roles in the project
   * List users in project
   */
  async projectUserListRaw(
    requestParameters: ProjectUserListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageProjectUser>> {
    const requestOptions = await this.projectUserListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageProjectUserFromJSON(jsonValue));
  }

  /**
   * Show all users with their roles in the project
   * List users in project
   */
  async projectUserList(
    requestParameters: ProjectUserListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageProjectUser> {
    const response = await this.projectUserListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectUserRoleDelete without sending the request
   */
  async projectUserRoleDeleteRequestOpts(
    requestParameters: ProjectUserRoleDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectUserRoleDelete().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectUserRoleDelete().'
      );
    }

    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling projectUserRoleDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/users/{user_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );
    urlPath = urlPath.replace("{user_id}", encodeURIComponent(String(requestParameters["userId"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a user from a project.
   */
  async projectUserRoleDeleteRaw(
    requestParameters: ProjectUserRoleDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.projectUserRoleDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a user from a project.
   */
  async projectUserRoleDelete(
    requestParameters: ProjectUserRoleDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectUserRoleDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for projectUserRoleUpdate without sending the request
   */
  async projectUserRoleUpdateRequestOpts(
    requestParameters: ProjectUserRoleUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectUserRoleUpdate().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectUserRoleUpdate().'
      );
    }

    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling projectUserRoleUpdate().'
      );
    }

    if (requestParameters["projectUserUpdate"] == null) {
      throw new runtime.RequiredError(
        "projectUserUpdate",
        'Required parameter "projectUserUpdate" was null or undefined when calling projectUserRoleUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/users/{user_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );
    urlPath = urlPath.replace("{user_id}", encodeURIComponent(String(requestParameters["userId"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectUserUpdateToJSON(requestParameters["projectUserUpdate"]),
    };
  }

  /**
   * Set the role of a user in a project.
   * Update user role in project
   */
  async projectUserRoleUpdateRaw(
    requestParameters: ProjectUserRoleUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectUser>> {
    const requestOptions = await this.projectUserRoleUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectUserFromJSON(jsonValue));
  }

  /**
   * Set the role of a user in a project.
   * Update user role in project
   */
  async projectUserRoleUpdate(
    requestParameters: ProjectUserRoleUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectUser> {
    const response = await this.projectUserRoleUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ProjectListOrderByEnum = {
  Code: "code",
  Code2: "-code",
  Name: "name",
  Name2: "-name",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type ProjectListOrderByEnum =
  (typeof ProjectListOrderByEnum)[keyof typeof ProjectListOrderByEnum];
/**
 * @export
 */
export const ProjectUserListOrderByEnum = {
  GivenName: "given_name",
  GivenName2: "-given_name",
  FamilyName: "family_name",
  FamilyName2: "-family_name",
  Email: "email",
  Email2: "-email",
} as const;
export type ProjectUserListOrderByEnum =
  (typeof ProjectUserListOrderByEnum)[keyof typeof ProjectUserListOrderByEnum];
